import { supabase } from '../lib/supabase';

// Convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    vehicleId: obj?.vehicle_id,
    driverId: obj?.driver_id,
    customerName: obj?.customer_name,
    customerEmail: obj?.customer_email,
    customerPhone: obj?.customer_phone,
    startDate: obj?.start_date,
    endDate: obj?.end_date,
    pickupLocation: obj?.pickup_location,
    dropoffLocation: obj?.dropoff_location,
    withDriver: obj?.with_driver,
    totalDays: obj?.total_days,
    vehicleCost: obj?.vehicle_cost,
    driverCost: obj?.driver_cost,
    totalCost: obj?.total_cost,
    status: obj?.status,
    notes: obj?.notes,
    createdBy: obj?.created_by,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

// Convert camelCase to snake_case
const toSnakeCase = (obj) => {
  return {
    vehicle_id: obj?.vehicleId,
    driver_id: obj?.driverId,
    customer_name: obj?.customerName,
    customer_email: obj?.customerEmail,
    customer_phone: obj?.customerPhone,
    start_date: obj?.startDate,
    end_date: obj?.endDate,
    pickup_location: obj?.pickupLocation,
    dropoff_location: obj?.dropoffLocation,
    with_driver: obj?.withDriver,
    total_days: obj?.totalDays,
    vehicle_cost: obj?.vehicleCost,
    driver_cost: obj?.driverCost,
    total_cost: obj?.totalCost,
    status: obj?.status,
    notes: obj?.notes,
  };
};

const create = async (bookingData) => {
  const { data, error } = await supabase?.from('vehicle_bookings')?.insert([toSnakeCase(bookingData)])?.select()?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const update = async (id, bookingData) => {
  const { data, error } = await supabase?.from('vehicle_bookings')?.update(toSnakeCase(bookingData))?.eq('id', id)?.select()?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const deleteMethod = async (id) => {
  const { error } = await supabase?.from('vehicle_bookings')?.delete()?.eq('id', id);

  if (error) throw error;
};

export const bookingService = {
  getAll,
  getById,
  create,
  update,
  delete: deleteMethod,
  subscribeToChanges,
};

async function getAll() {
  const { data, error } = await supabase
    ?.from('vehicle_bookings')
    ?.select(`
      *,
      vehicle:vehicles(*),
      driver:drivers(*)
    `)
    ?.order('created_at', { ascending: false });

  if (error) throw error;
  return data?.map(toCamelCase) || [];
}

async function getById(id) {
  const { data, error } = await supabase
    ?.from('vehicle_bookings')
    ?.select(`
      *,
      vehicle:vehicles(*),
      driver:drivers(*)
    `)
    ?.eq('id', id)
    ?.single();

  if (error) throw error;
  return toCamelCase(data);
}

async function subscribeToChanges(callback) {
  const channel = supabase
    ?.channel('vehicle_bookings')
    ?.on('postgres_changes', { event: '*', schema: 'public', table: 'vehicle_bookings' }, (payload) => {
      callback(payload);
    })
    ?.subscribe();

  return () => supabase?.removeChannel(channel);
}